module.exports = __webpack_public_path__ + "img/environment.8902d898.jpg";